import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  unifierCalculationTypesList: [],
  isCalculationTypesLoading: true,
  page: 0,
  rowsPerPage: 10,
  sort: {
    keytoSort: "id",
    direction: "desc",
  },
  selectedRow: {},
  openModalType: "",
  // table head search + filters
  selectedCalculationName: null,
  selectedMissedRun: [],
  selectedDocumented: [],
  selectedActive: [],
};

const unifierCalculationTypesSlice = createSlice({
  name: "unifierCalculationTypes",
  initialState,
  reducers: {
    setUnifierCalculationTypesList: (state, action) => {
      state.unifierCalculationTypesList = action.payload;
    },
    setIsCalculationTypesLoading: (state, action) => {
      state.isCalculationTypesLoading = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setSelectedRow: (state, action) => {
      state.selectedRow = action.payload;
    },
    setOpenModalType: (state, action) => {
      state.openModalType = action.payload;
    },
    setSelectedCalculationName: (state, action) => {
      state.selectedCalculationName = action.payload;
    },
    setSelectedMissedRun: (state, action) => {
      state.selectedMissedRun = action.payload;
    },
    setSelectedDocumented: (state, action) => {
      state.selectedDocumented = action.payload;
    },
    setSelectedActive: (state, action) => {
      state.selectedActive = action.payload;
    },
  },
});

export const {
  setUnifierCalculationTypesList,
  setIsCalculationTypesLoading,
  setPage,
  setRowsPerPage,
  setSort,
  setSelectedRow,
  setOpenModalType,
  setSelectedCalculationName,
  setSelectedMissedRun,
  setSelectedDocumented,
  setSelectedActive,
} = unifierCalculationTypesSlice.actions;

export default unifierCalculationTypesSlice.reducer;
